import Slider from './slider/Slider';

export function init(element: HTMLElement) {
  console.log('content-card-slider.init()');

  new Slider(element, {navigation: true, pagination: true});
}

export default init;
